import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export const ClaimsIcon = (props) => {
    return (_jsx(SvgIcon, { ...props, children: _jsx("svg", { fill: 'currentColor', width: '24px', height: '24px', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M3,23H13a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1V22A1,1,0,0,0,3,23ZM4,11h8V21H4Zm12,7V7H7A1,1,0,0,1,7,5H17a1,1,0,0,1,1,1V18a1,1,0,0,1-2,0ZM22,2V15a1,1,0,0,1-2,0V3H11a1,1,0,0,1,0-2H21A1,1,0,0,1,22,2Z' }) }) }));
};
